export const theme = {
  colors: {
    primary: "#000000",
    background: "#ffffff",
    accent: "#f8f4e3",

    neonGreen: "#39FF14",
    neonBlue: "#00FFFF",

    text: "#ffffff",

    // ---------- Cyberpunk Gradients ----------
    heroOverlay: "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.75))",

    animatedStops: {
      g1: "#7B3EF0",
      g2: "#C85AD0",
      g3: "#F9840A",
    },

    // Same gradient used for curve + highlight text
    flowingGradient:
      "linear-gradient(90deg, #7B3EF0, #C85AD0, #F9840A, #7B3EF0)",
  },

  heroBackground:
    'url("https://cdn.shopify.com/s/files/1/0851/4607/5431/files/istockphoto-178447404-612x612.jpg?v=1763888390") center/cover no-repeat',

  fonts: {
    primary: "'Inter', sans-serif",
  },

  sizes: {
    titleSize: "6rem",
    linkSize: "1.5rem",
  },

  // --------------------------------------
  // 🌈 Smooth Gradient Animation Utilities
  // --------------------------------------
  animations: {
    gradientAnimation: `
      @keyframes flow {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `,
  },

 mixins: {
  smoothGradient: `
    background: linear-gradient(90deg, #7B3EF0, #C85AD0, #F9840A, #7B3EF0);
    background-size: 400%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: flow 8s ease-in-out infinite;
  `,

  shiningEffect: `
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -150%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        75deg,
        transparent 0%,
        rgba(255, 255, 255, 0.8) 45%,
        transparent 100%
      );
      transform: skewX(-20deg);
      animation: shine 2.5s ease-in-out infinite;
    }
  `,
},
glowGradient: `
  filter: drop-shadow(0 0 6px rgba(124, 63, 240, 0.6))
          drop-shadow(0 0 12px rgba(200, 90, 208, 0.5))
          drop-shadow(0 0 20px rgba(249, 132, 10, 0.4));
`,
};
